var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('router-view',{attrs:{"name":"sidebar"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }